// src/components/HelpInfo.tsx
import React, { useState } from "react";
import { Row, Card, Typography } from "antd";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import "./HelpInfo.css";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { ICmsUsefulInformation } from "../../Orchestrator/Types/Interface/ICmsUsefulInformaton";
import { useOnLanguageChange } from "../CustomHooks/useOnLanguageChange";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { _eventBus } from "../../core/events/EventBus";
import { rememberBackPath, BACK_PATH_KEYS } from "../../Lib/Utils/backNavigation";

const HelpInfo = () => {
  const intl = useIntl();
  const [usefulInformation] = useRecState<ICmsUsefulInformation[]>('usefulInformationAtom');
  const [showAll, setShowAll] = useState(false);
  useOnLanguageChange(() => {
    _eventBus.emit({
      eventName: evtTree.helpInfo.Get,
    });
  });

  const displayedInformation = showAll ? usefulInformation : usefulInformation.slice(0, 4);

  const onCardClick = ({ slug }: { slug: string }) => {
    if (slug && slug != "") {
      rememberBackPath(BACK_PATH_KEYS.usefulInfo);
      _eventBus.emit({
        eventName: evtTree.helpInfo.Details.Click,
        data: { slug }
      });
    }
  }

  return (
    <Card className="text-center bg-F7F2EE radius-24 shadow-unset help-info-card">
      <Typography.Title className="fs-34 fw-600 ff-wallop title">
        {intl.formatMessage({ id: "usefulInfo" }).toUpperCase()}
      </Typography.Title>
      <Row gutter={16} justify="center" align={"middle"} className="gap-10 help-info-row">
        {
          !usefulInformation.length ?
            <div className="d-flex flex-col align-items-center justify-content-center gap-8 h-50">
              <Typography.Text>
                {intl.formatMessage({
                  id: "noHelpAndUsefulInformationAvailable",
                })}
              </Typography.Text>
            </div>
            : <>
              {displayedInformation?.map((item, index) => (
                <Card
                  key={index}
                  className="text-center bg-transparent shadow-unset w-fit-content help-card cursor-pointer"
                  onClick={() => { onCardClick({ slug: item.slug }) }}
                >
                  <div className="icon-container help-card">
                    <img
                      src={item?.help_icon?.icon?.url || ""}
                      alt={item.label}
                      className="help-icon"
                    />
                  </div>
                  <div className="fs-17 fw-700">{item.label}</div>
                </Card>
              ))}
              {usefulInformation.length > 4 && (
                <Card
                  className="text-center bg-transparent shadow-unset w-fit-content cursor-pointer"
                  onClick={() => setShowAll(prev => !prev)}
                >
                  <Typography.Text className="see-all-text">
                    {showAll === false &&
                      intl.formatMessage({ id: "seeAll" })
                    }

                    {intl?.locale === "ar" ? (
                      showAll === false && <ArrowLeftOutlined />
                    ) : (
                      showAll === false && <ArrowRightOutlined />
                    )}
                  </Typography.Text>
                </Card>
              )}
            </>
        }
      </Row>
    </Card>
  );
};

export default HelpInfo;
